import React from "react"
import PropTypes from "prop-types"
import { withMutation } from "store/Mutation"

import FormHelperText from '@material-ui/core/FormHelperText';

class FormErrors extends React.Component {
  static propTypes = {
    mutation: PropTypes.object,
    field: PropTypes.string,
  }

  _renderErrors(errors, prop, otherProps) {
    if (errors.length === 0) {
      return null
    }

    return (
      <div {...otherProps}>
        {errors.map(e => (
          <FormHelperText error key={e}>
            {e[prop]}
          </FormHelperText>
        ))}
        <br />
      </div>
    )
  }

  render() {
    const { mutation, field, ...otherProps } = this.props

    if (field) {
      const errors = mutation.validationErrors(field)
      if (!errors) {
        return null
      }

      return this._renderErrors(errors, "message", otherProps)
    } else {
      const errors = mutation.validationErrors()
      if (!errors) {
        return null
      }

      return this._renderErrors(errors, "fullMessage", otherProps)
    }
  }
}

export default withMutation()(FormErrors)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Form/FormErrors.js